// CHART-KB: the vocabulary of the Keystones lens (a seat's quarterly priorities, `goal.kind =
// priority`, with milestones) and of seat completeness (the setup items a seat needs), shared
// by the chart's cards, the side panel and Setup › Chart. Pure.
import type { CompletenessItem, LensBand } from "@companyos/domain-work/org";
import type { Goal } from "../../api/types";

export type Track = Goal["track"];

export const TRACKS: readonly Track[] = ["on", "at_risk", "off"];

export const TRACK_LABELS: Record<Track, string> = {
  on: "On track",
  at_risk: "At risk",
  off: "Off track",
};

/** The band a priority's track reads in (a dot, never colour alone: the label is beside it). */
export const TRACK_BAND: Record<Track, LensBand> = {
  on: "green",
  at_risk: "amber",
  off: "red",
};

/** What each completeness item is, as the panel and Setup › Chart name it. */
export const COMPLETENESS_LABELS: Record<CompletenessItem, string> = {
  holder: "A holder, or an open seat's hiring status",
  reports_to: "Reports to a seat",
  team: "In a team",
  responsibility: "At least one responsibility",
  measurable: "A measurable with a target",
  finance: "A budget or a cost line",
  keystone: "A priority this quarter",
};

/** The one-line hint under each item in Setup › Chart. */
export const COMPLETENESS_HINTS: Record<CompletenessItem, string> = {
  holder:
    "Someone holds the seat, or it is marked open (hiring); a proposed seat is not decided yet.",
  reports_to: "A supervisor on the chart; the top of the chart is exempt.",
  team: "The seat is a member of at least one team.",
  responsibility: "An active responsibility on the seat.",
  measurable: "A scorecard metric on the seat with a target (needs the KPI add-on).",
  finance: "A budget on the seat, or a cost line this month.",
  keystone: "A priority (goal.kind = priority) for the current quarter.",
};

/** What a person does about a missing item (the panel's "Add …" action label). */
export const COMPLETENESS_ACTIONS: Record<CompletenessItem, string> = {
  holder: "Assign a holder",
  reports_to: "Set reports to",
  team: "Add to a team",
  responsibility: "Add a responsibility",
  measurable: "Add a measurable",
  finance: "Set a budget",
  keystone: "Add a priority",
};
